module.exports = __webpack_public_path__ + "static/media/headerbg2.0246d512.png";